import { formatTextToHtml } from '@shared/helpers/text';

export const getProductNotes = (description: string, isExpanded: boolean): string => {
    const maxLength = 50;

    if (!description) return '';

    if (isExpanded) {
        return formatTextToHtml(description);
    }

    const hasMultipleLines = description.includes('\n');
    const normalizedLength = description.replace(/\s+/gu, ' ')
        .trim().length;

    // If single line and fits within maxLength, show full text
    if (!hasMultipleLines && normalizedLength <= maxLength) {
        return formatTextToHtml(description);
    }

    // If has multiple lines, show only first line (truncated if needed)
    // If single line but too long, truncate it
    const [firstLine] = description.split('\n');
    const firstLineNormalized = firstLine.replace(/\s+/gu, ' ')
        .trim();

    if (firstLineNormalized.length <= maxLength) {
        return `${firstLineNormalized}....`;
    }

    return `${firstLineNormalized.slice(0, maxLength)}....`;
};
